import React from "react";
import { Button, SystemIcon } from "@justworkshr/milo-components";
import styles from "./Congratulations.module.css";
import { getCWRedirectUrl } from "utils/helper";

const CongratulationsPage = (): JSX.Element => {
  return (
    <div className={styles.congratulationContainer}>
      <SystemIcon iconName="check" color="inverse" size="extra-large" />

      <div className={styles.success}>
        Your application was successfully submitted.
      </div>

      <p>We’ll review it and reach out if we need any additional info. </p>

      <p>Otherwise, we’ll send a reply in 3-5 days.</p>
      <p>
        Don’t forget - you’ll need a U.S.-based business banking account to sign
        up.
      </p>
      <p>
        <Button
          variant="outlined"
          as="a"
          href={getCWRedirectUrl("/onboarding_checklist")}
        >
          Back to dashboard
        </Button>
      </p>
    </div>
  );
};

export default CongratulationsPage;
